import { render, staticRenderFns } from "./bangDing.vue?vue&type=template&id=8ab63cfe&scoped=true&"
import script from "./bangDing.vue?vue&type=script&lang=js&"
export * from "./bangDing.vue?vue&type=script&lang=js&"
import style0 from "./bangDing.vue?vue&type=style&index=0&id=8ab63cfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab63cfe",
  null
  
)

export default component.exports